import { UtilsService } from 'src/app/shared/services/utils.service';
import { GtagService } from 'src/app/gtag/gtag.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { L10nTranslationService } from '@snack-dev/angular-l10n';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs';
import { CartService } from 'src/app/shared/services/cart.service';
import { SubscriptionDetail, Subscriptions } from 'src/app/shared/models/subscriptions.model';
import { ChatService } from 'src/app/shared/services/chat.service';
import { InitService } from 'src/app/shared/services/init.service';
import { Price } from '../../../shared/models/price.model';
import { Track } from '../../../shared/models/tracks-sfx/track.model';
import { ExperimentsService } from '../../../shared/services/experiments.service';

@Component({
  selector: 'hs-track-modal-v2',
  templateUrl: './track-modal-v2.component.html',
  styleUrls: ['./track-modal-v2.component.scss'],
})
export class TrackModalV2Component implements OnInit, OnDestroy {
  track: Track;
  selectedPrice: Price;

  subscription: Subscription = null;
  subscriptions: Subscriptions;
  /**
   * Annually subscriptions are shown by default.
   */
  monthly = false;
  /**
   * Pro subscriptions are shown by default.
   */
  proSelected = true;

  constructor(
    public bsModalRef: BsModalRef,
    private cart: CartService,
    private init: InitService,
    private translation: L10nTranslationService,
    private router: Router,
    private chat: ChatService,
    public gtag: GtagService,
    private utils: UtilsService,
    private experimentsService: ExperimentsService
  ) { }

  ngOnInit() {
    this.subscription = this.init.data.subscribe((response) => {
      this.subscriptions = response.subscriptions;
    });
    this.selectedPrice = this.track.prices.find((price) => price.default);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  setSelected(price: Price) {
    this.selectedPrice = price;
  }

  addSubscriptionToCart() {
    this.bsModalRef.hide();
    this.cart.addSubscription(this.getCurrentSubscription(), this.monthly).subscribe(() => {
      this.router.navigate(['/checkout']);
    });
  }

  getFullAccess() {
    this.bsModalRef.hide();
    this.router.navigate(['/premium']);
  }


  private getCurrentSubscription(): SubscriptionDetail {
    if (this.proSelected) {
      if (this.monthly) {
        return this.subscriptions.pro.monthly;
      } else {
        return this.subscriptions.pro.annually;
      }
    } else {
      if (this.monthly) {
        return this.subscriptions.business.monthly;
      } else {
        return this.subscriptions.business.annually;
      }
    }
  }

  buy(price: Price) {
    this.bsModalRef.hide();
    if (this.experimentsService.isPopupAddedToCartVariant()) {
      this.addTrackToCart(price).subscribe(() => {});
    } else {
      this.addTrackToCart(price).subscribe(() => {
        this.router.navigate(['/checkout']);
      });
    }
  }

  addTrackToCart(price: Price): Observable<void>  {
    // this.bsModalRef.hide();
    return this.cart.addTrack(this.track, price);
  }

  addTrackAndHide(price: Price) {
    this.cart.addTrack(this.track, price).subscribe(response => {
      this.bsModalRef.hide();
    });
  }

  closeEvent() {
    if (this.utils.isBrowser) {
      this.gtag.close(window.location.pathname);
    }
  }
}
